
export const languageNameMapping = {
    'en': 'English',
    'fr': 'French',
    'id-ID': 'Indonesian',
    "ar": "Arabic",
    "en": "English",
    "fr": "French",
    "es": "Spanish",
    "ko": "Korean",
    "it": "Italian",
    "ja": "Japanese",
    "de-BE": "German",
    "zh": "Chinese",
    "tr": "Turkish",
    "ur": "Urdu",
    'ru': 'Russian',
};
